import common from './common';

// pages
import homePage from './pages/home';
import errorsPage from './pages/errors';
import sessionPage from './pages/session';
import studentPage from './pages/student';
import teacherPage from './pages/teacher';
import preSettingModulesPage from './pages/preSettingModules';
import avatarsPage from './pages/avatars';
import protoWordPage from './pages/protoWord';
import studentHomePage from './pages/student/home';
import studentTasksPage from './pages/student/tasks';
import studentTypingPage from './pages/student/typing';
import teacherSessionResultPage from './pages/teacher/sessionResult';

// components - UI
import uiComponents from './components/ui';

// components - modules
import moduleCommon from './components/modules/common';
import cardWriting from './components/modules/cardWriting';
import correctTheMistakes from './components/modules/correctTheMistakes';
import seedLetter from './components/modules/seedLetter';
import oxQuiz from './components/modules/oxQuiz';
import segmentedReading from './components/modules/segmentedReading';
import sentenceOrdering from './components/modules/sentenceOrdering';
import wordCheck from './components/modules/wordCheck';
import wordSelection from './components/modules/wordSelection';
import wordWriting from './components/modules/wordWriting';
import magicWordTest from './components/modules/magicWordTest';
import postIt from './components/modules/postIt';
import talkQuiz from './components/modules/talkQuiz';

// components - session
import sessionCommon from './components/session/common';
import sessionResults from './components/session/results';

// components - teacher
import teacherComponents from './components/teacher';

// components - layers
import teacherStarLayer from './components/layers/teacherStarLayer';
import focusScreenLayer from './components/layers/focusScreenLayer';

// components - proto-word
import protoWord from './components/proto-word/index';

export default {
    ...common,
    pages: {
        home: homePage,
        errors: errorsPage,
        session: sessionPage,
        student: {
            ...studentPage,
            home: studentHomePage,
            tasks: studentTasksPage,
            typing: studentTypingPage,
        },
        teacher: {
            ...teacherPage,
            sessionResult: teacherSessionResultPage,
        },
        preSettingModules: preSettingModulesPage,
        avatars: avatarsPage,
        protoWord: protoWordPage,
    },
    components: {
        ui: uiComponents,
        protoWord: {
            ...protoWord,
        },
        layers: {
            teacherStarLayer,
            focusScreenLayer,
        },
        session: {
            common: sessionCommon,
            results: sessionResults,
        },
        modules: {
            common: moduleCommon,
            cardWriting,
            correctTheMistakes,
            seedLetter,
            oxQuiz,
            segmentedReading,
            sentenceOrdering,
            wordCheck,
            wordSelection,
            wordWriting,
            magicWordTest,
            postIt,
            talkQuiz,
        },
        teacher: teacherComponents,
    },
};
